import $ from 'jquery';
import carousels from '../framework/carousel';

$('.timeline__slider').each((index, item) => {
  const $carousel = $(item);
  const parentId = $carousel.attr('id');

  const settings = {
    autoplay: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    initialSlide: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false,
          centerMode: false,
        }
      }
    ]
  };

  const slidesSelector = `#${parentId} .timeline__slides`;
  const $slider = $(slidesSelector);

  if ($slider.length) {
    const slickInstance = carousels(slidesSelector, settings);

    const $buttons = $('.timeline__mobile-years .timeline__slide--year');
    $buttons.removeClass('is-active');
    $buttons.eq(settings.initialSlide).addClass('is-active');

    $buttons.each((i, btn) => {
      $(btn).on('click', () => {
        $slider.slick('slickGoTo', i);
      });
    });

    // Update visible buttons on slide change
    $slider.on('afterChange', (event, slick, currentSlide) => {
        const $yearRow = $('.timeline__mobile-years');
        const $buttons = $yearRow.find('.timeline__slide--year');
      
        // Remove old active class
        $buttons.removeClass('is-active');
        const $activeButton = $buttons.eq(currentSlide);
        $activeButton.addClass('is-active');
      
        // Smooth scroll the active button into view
        $activeButton[0].scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        });
      });
      
  }
});
